import { collection, deleteDoc, getDocs, orderBy, query, updateDoc } from "firebase/firestore/lite";
import { Component } from "react";
import { dbPublic } from "../../App";
import Toolbar from "../components/toolbar";
import { FaTrash } from "react-icons/fa";
import { IoEye } from "react-icons/io5";
import { CgCloseO } from "react-icons/cg";
import { MdPrint } from "react-icons/md";

class Applications extends Component<any,any> {

    constructor(props:any) {
        super(props);
        this.state = {
            applications: [],
            application: {},
            viewing: false,
        }
    }

    async componentDidMount() {
        var tCol = collection(dbPublic,'applications');
        var tSnap = await getDocs(query(tCol,orderBy("isRead",'asc'), orderBy("date",'desc')));
        this.setState({applications: tSnap.docs});
    }

    render() {
        return (
            <div style={{height: '100%', fontFamily: 'avenir'}}>
                <Toolbar />
                <section style={{marginLeft: '210px',height: '100%',display: 'flex',flexDirection:'column', justifyContent: 'flex-start', alignItems: 'flex-start'}}>
                    <div style={{width: '100%', fontFamily: 'avenirb', fontSize: '30pt'}}>
                        APPLICATIONS
                    </div>
                    <div>
                        <div style={{fontFamily: 'avenirb'}}></div>
                        View or Print applications<br/><br/>
                        There are currently {this.state.applications.length} applications.<br/><br/>
                    </div>
                    <div style={{display: 'flex',borderBottom: '1px dotted #000'}}>
                        <div style={{width: '150px'}}><b>Date</b></div>
                        <div style={{width: '200px'}}><b>Name</b></div>
                        <div style={{width: '200px'}}><b>Primary Email</b></div>
                        <div style={{width: '150px'}}><b>Phone</b></div>
                        <div style={{width: '200px'}}><b></b></div>
                    </div>
                    {this.state.applications.map((apps:any,i:number)=>{
                        var a = apps.data();
                        var email = a.emails.split(/\s/);
                        return (
                            <div style={{display: 'flex',borderBottom: '1px dotted #000', fontSize: '10pt', paddingTop: '5px', paddingBottom: '5px', backgroundColor: a.isRead == false ? 'rgba(200,0,0,.2)' : 'rgba(255,255,255,1)', fontFamily: a.isRead == false ? 'avenirb' : 'avenir'}}>
                                <div style={{width: '150px'}}><b>{new Date(a.date.seconds * 1000).toLocaleString()}</b></div>
                                <div style={{width: '200px'}}><b>{a.name}</b></div>
                                <div style={{width: '200px'}}><b>{email[0].toLowerCase()}</b></div>
                                <div style={{width: '150px'}}><b>{a.cell1}</b></div>
                                <div style={{width: '200px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}><b>
                                    

                                    <IoEye size={25} style={{marginRight: '30px', cursor: 'pointer', color: 'rgba(0,200,0,1)'}} onClick={async ()=>{
                                        updateDoc(apps.ref,{isRead: true});
                                        this.setState({viewing: true, application: apps});
                                    }}/>

                                    <FaTrash size={15} style={{marginRight: '30px', cursor: 'pointer', color: 'rgba(200,0,0,1)'}} onClick={async ()=>{
                                        var tCol = collection(dbPublic,'appliations');
                                        await deleteDoc(apps.ref);
                                        var tSnap = await getDocs(query(tCol,orderBy("isRead",'asc'), orderBy("date",'desc')));
                                        this.setState({applications: tSnap.docs});
                                    }}/>
                                </b></div>
                            </div>
                        );
                    })}
                    {this.state.viewing ?
                    <div style={{position: 'absolute', top: '0px', left: '0px', width: '100%', height: '100%', backgroundColor: 'rgba(255,255,255,1)', display: 'flex', justifyContent: 'center', alignItems: 'center',overflow: 'scroll'}}>
                        <div className="closeWindow no-print" onClick={async ()=>{
                            var tCol = collection(dbPublic,'applications');
                            getDocs(query(tCol,orderBy("isRead",'asc'), orderBy("date",'desc'))).then(tSnap => {
                                this.setState({viewing: false, application: {},applications: tSnap.docs});
                            });
                            
                        }}>
                            <CgCloseO /> Close
                        </div>
                        <div className="closeWindow no-print" style={{right: 125}} onClick={async ()=>{
                            window.print();
                            
                        }}>
                            <MdPrint /> Print
                        </div>
                        <div style={{position: 'absolute', top: 0}}>
                            <div style={{width: '800px', height: '100px', display: 'flex', alignItems: 'center', marginBottom: 20,}}>
                                <img src='/content/images/logo-hires.png' style={{width: '100px', objectFit: 'contain'}}/>
                                <div style={{fontSize: '40pt', fontFamily: 'avenirb'}}>Puppy Application Form</div>
                            </div>
                            <div style={{fontSize: '12pt', fontFamily: 'avenir'}}>
                                APPLICATION DATE: <b>{new Date(this.state.application.data().date.seconds * 1000).toLocaleString()}    </b>
                            </div>
                            <div style={{fontSize: '12pt', fontFamily: 'avenir', marginBottom: 20}}>
                                APPLICATION ID: <b>{this.state.application.id}</b>
                            </div>
                            <div style={{}}>
                                <div style={{fontSize: '12pt', fontFamily: 'avenir'}}>
                                    First and Last Name(s):
                                </div>
                                <div style={{fontSize: '16pt', fontFamily: 'avenirb', marginBottom: 20, borderBottom: '1px dotted #000'}}>
                                    {this.state.application.data().name}
                                </div>

                                <div style={{fontSize: '12pt', fontFamily: 'avenir'}}>
                                    Full Address:
                                </div>
                                <div style={{fontSize: '16pt', fontFamily: 'avenirb', marginBottom: 20, borderBottom: '1px dotted #000'}}>
                                    {this.state.application.data().address}
                                </div>

                                <div style={{fontSize: '12pt', fontFamily: 'avenir'}}>
                                    Email Addresses (all applicants):
                                </div>
                                <div style={{fontSize: '16pt', fontFamily: 'avenirb', marginBottom: 20, borderBottom: '1px dotted #000'}}>
                                    {this.state.application.data().emails.replace(/\s/g,', ').toLowerCase()}
                                </div>

                                <div style={{display: 'flex'}}>
                                    <div style={{fontSize: '12pt', fontFamily: 'avenir', width: '250px'}}>
                                        Cell Number (1):
                                    </div>
                                    <div style={{fontSize: '12pt', fontFamily: 'avenir', width: '250px'}}>
                                        Cell Number (2):
                                    </div>
                                    <div style={{fontSize: '12pt', fontFamily: 'avenir', width: '250px'}}>
                                        Cell Number (3):
                                    </div>
                                </div>
                                <div style={{display: 'flex',marginBottom: 20}}>
                                    <div style={{width: '240px',fontSize: '16pt', fontFamily: 'avenirb', marginBottom: 10, borderBottom: '1px dotted #000'}}>
                                        {this.state.application.data().cell1}
                                    </div>
                                    <div style={{width: '240px',marginLeft: 10,fontSize: '16pt', fontFamily: 'avenirb', marginBottom: 10, borderBottom: '1px dotted #000'}}>
                                        {this.state.application.data().cell2}
                                    </div>
                                    <div style={{width: '240px',marginLeft: 10,fontSize: '16pt', fontFamily: 'avenirb', marginBottom: 10, borderBottom: '1px dotted #000'}}>
                                        {this.state.application.data().cell3}
                                    </div>
                                </div>

                                <div style={{display: 'flex',marginBottom: 20}}>
                                    <div style={{fontSize: '12pt', fontFamily: 'avenir'}}>
                                        Have you owned a pet before?&nbsp;&nbsp;
                                    </div>
                                    <div style={{fontSize: '12pt', fontFamily: 'avenirb'}}>
                                        {this.state.application.data().ownedpet}
                                    </div>
                                </div>

                                <div style={{fontSize: '12pt', fontFamily: 'avenir'}}>
                                    If yes, where are they now?&nbsp;&nbsp;
                                </div>
                                <div style={{marginBottom: 20,fontSize: '12pt', fontFamily: 'avenirb',borderBottom: '1px dotted #000'}}>
                                    {this.state.application.data().ownedpet_where}
                                </div>

                                <div style={{fontSize: '12pt', fontFamily: 'avenir'}}>
                                    Why are you looking for a Bulldog?&nbsp;&nbsp;
                                </div>
                                <div style={{marginBottom: 20,fontSize: '12pt', fontFamily: 'avenirb',borderBottom: '1px dotted #000'}}>
                                    {this.state.application.data().why}
                                </div>

                                <div style={{display: 'flex',marginBottom: 20}}>
                                    <div style={{fontSize: '12pt', fontFamily: 'avenir', marginBottom: 10, }}>
                                        Do you own or rent you home?&nbsp;&nbsp;
                                    </div>
                                    <div style={{fontSize: '12pt', fontFamily: 'avenirb'}}>{this.state.application.data().ownrent}</div>
                                    
                                    <div style={{marginLeft: 20,fontSize: '12pt', fontFamily: 'avenir', marginBottom: 10, }}>
                                        Do you have a fenced back yard?&nbsp;&nbsp;
                                    </div>
                                    <div style={{fontSize: '12pt', fontFamily: 'avenirb'}}>{this.state.application.data().fenced}</div>

                                    <div style={{marginLeft: 20,fontSize: '12pt', fontFamily: 'avenir', marginBottom: 10, }}>
                                        Maximum number of hours your dog will be alone?&nbsp;&nbsp;
                                    </div>
                                    <div style={{fontSize: '12pt', fontFamily: 'avenirb'}}>{this.state.application.data().alone} hrs.</div>
                                </div>
                                
                                <div style={{fontSize: '12pt', fontFamily: 'avenir'}}>
                                    Have you ever surrendered a pet to an animal shelter? If yes, please provide details. 
                                </div>
                                <div style={{marginBottom: 20,fontSize: '12pt', fontFamily: 'avenirb',borderBottom: '1px dotted #000'}}>
                                    {this.state.application.data().surrendered}
                                </div>

                                <div style={{display: 'flex',marginBottom: 20}}>
                                    <div style={{fontSize: '12pt', fontFamily: 'avenir', marginBottom: 10, }}>
                                        Are you willing to sign CKC Non-Breeding Contract and agree that this Bulldog will not be bred under any circumstance?&nbsp;&nbsp;
                                    </div>
                                    <div style={{fontSize: '12pt', fontFamily: 'avenirb'}}>{this.state.application.data().breeding}</div>
                                </div>

                                <div style={{display: 'flex',marginBottom: 20}}>
                                    <div style={{fontSize: '12pt', fontFamily: 'avenir', marginBottom: 10, }}>
                                    Are you willing to provide Spay/Neuter confirmation signed by your vet by pet age of 2?&nbsp;&nbsp;
                                    </div>
                                    <div style={{fontSize: '12pt', fontFamily: 'avenirb'}}>{this.state.application.data().spayneuter}</div>
                                </div>

                                <div style={{display: 'flex',marginBottom: 20}}>
                                    <div style={{fontSize: '12pt', fontFamily: 'avenir', marginBottom: 10, }}>
                                    What is your preference:  Male, Female or Doesn’t Matter? &nbsp;&nbsp;
                                    </div>
                                    <div style={{fontSize: '12pt', fontFamily: 'avenirb'}}>{this.state.application.data().gender}</div>
                                </div>

                                <div style={{display: 'flex',marginBottom: 20}}>
                                    <div style={{fontSize: '12pt', fontFamily: 'avenir', marginBottom: 10, }}>
                                    Would you consider something other then stated preference (Yes/No)?&nbsp;&nbsp;
                                    </div>
                                    <div style={{fontSize: '12pt', fontFamily: 'avenirb'}}>{this.state.application.data().othergender}</div>
                                </div>

                                <div style={{fontSize: '12pt', fontFamily: 'avenir'}}>
                                Please provide 2 references (vet is preferred, if possible; and someone who knows you for more then 5 years. We will advise you few days prior to contacting your references. 
                                </div>
                                <div style={{whiteSpace: 'pre-line',marginBottom: 20,fontSize: '12pt', fontFamily: 'avenirb'}}>
                                    <text>{this.state.application.data().references}</text>
                                </div>

                            </div>
                        </div>
                    </div>
                    : null}
                </section>
            </div>
        );
    }
}

export default Applications;